<template>
  <div class="deposit-container py-4 col-12 col-lg-8  mx-auto mb-5">
    <h4 class="w-100 text-center text-white my-3 my-lg-5 page-main-title">
      Депозит
    </h4>

    <div id="deposit-area" class="col-12 mx-auto deposit-main-area px-0">
      <div v-if="depositMethods.length" class="row mx-0 ">
        <div class="col-12 col-sm-12 px-2 px-lg-0 py-3 py-md-4 page-dark-bg ">
          <div class="w-100 text-white px-3 mb-2 text-center">
            <span class="choose-method-txt">Выберите способ пополнения</span>
          </div>
          <div class="col-12 px-0">
            <div class="col-12 px-0 col-lg-9 mx-auto row mx-0 justify-content-around">
              <div
                      v-for="method in depositMethods" :key="method.id"
                      class="paymethod-label pay-method-itm-style col-sm-6 col-md-4 col-lg-3"
                      :class="[method.id === selectedMethod.id ? 'selected' : '']"
                      @click="selectMethod(method)"
                      v-lazy-container="{ selector: 'img', loading: require('@/../public/images/icons/main-loader.svg') }"
              >
                <img
                        :src="getPictureUrl(method.picture)"
                        :data-src="getPictureUrl(method.picture)"
                        :alt="'VipMagnit казино пополнение баланса - метод  '+method.name"
                        class="pay-method-image m-auto"
                >
                <div  class="min-amount-label">
                    <span class="control-label">
                        Мин. {{ method.min_amount }} руб. <br />
                        Макс. {{ method.max_amount }} руб. <br />
                    </span>
                </div>
              </div>
              <div class="paymethod-label pay-method-itm-style col-sm-6 col-md-4 col-lg-3 promo-method">
                <button class="btn main-btn m-auto" @click="$root.$emit('bv::show::modal','ActivatePromoCode')">
                  Промо-код
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5" v-if="amountAlert">
               <span class="red-color deposit-hint">
                  Уважаемый клиент, обратите внимание, что сумма может быть изменена. Пожалуйста, проверьте окончательную сумму на странице оплаты. В случае неоплаты корректной суммы заявка может не быть успешно обработана.
               </span>
        </div>
        <div v-if="selectedMethod.id && userData"
             class="col-12 col-sm-12 row mx-0 justify-content-between px-0 bg-dark-red mt-4 py-5">
          <div class="col-12 col-lg-4">
            <span class="gray-color deposit-hint">Минимальное пополнение за раз {{selectedMethod.minAmount}} руб.</span><br>
            <span class="gray-color deposit-hint">Максимальное пополнение за раз {{selectedMethod.maxAmount}} руб.</span>
          </div>
          <div class="col-12 col-lg-8">
            <b-form
                    id="deposit-form"
                    class="mx-0 deposit-form row mx-0 justify-content-start"
                    method="POST"
                    :action="$_config.payInUrl"
                    @submit="payInFormSubmit">
              <div class="col-12 col-lg-4 input-group pl-lg-0 mb-3 mb-lg-0">
                  <input
                          id="depositAmount"
                          ref="depositAmount"
                          v-model="sum"
                          class="form-control main-input"
                          placeholder="Сумма в рублях"
                          type="text"
                          required
                          name="payin_amount"
                          autocomplete="off"
                  >
                </div>

              <div v-if="sum" class="col-12 col-lg-3 px-lg-0 mb-3 mb-lg-0">
                <div class="col-12 input-group px-0">
                  <label class="payin-info">
                    <span class="pay-amount-info d-block">К оплате : {{ sum }} Руб</span>
                    <span class="pay-method-info">{{ selectedMethod.name ? 'Через : ' + selectedMethod.name : '' }}</span>
                  </label>
                </div>
              </div>

              <div class="col-12 col-lg-5 px-0 px-3">
                <div class="green-btn-bg">
                  <button class="btn main-btn w-100 text-white" type="submit">
                    Пополнить
                  </button>
                </div>
              </div>
              <div class="form-group row">
                <input v-model="selectedMethod.id" type="hidden" name="method">
                <input v-model="selectedMethod.module" type="hidden" name="selected_system">
              </div>

              <b-col cols="12" class="px-0 col-md-12 col-lg-11 mx-0 mx-lg-auto">
                <Alert :message="formResponse"></Alert>
              </b-col>
            </b-form>
          </div>
        </div>
      </div>
      <div v-else class="row justify-content-center w-100 color-red mx-0 h-100 py-4">
        <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
      </div>
    </div>
    <ActivatePromoCode></ActivatePromoCode>
  </div>

</template>

<script>
import ActivatePromoCode from '../payments/ActivatePromoCode'
import Alert from '@/components/Alert'

export default {
  name: 'Deposit',
  data () {
    return {
      sum: null,
      amountAlert:false,
      selectedMethod: {
        id: null,
        module: '',
        name: '',
        minAmount:null,
        maxAmount:null
      },
      formResponse: null
    }
  },
  components: {
    ActivatePromoCode,
    Alert
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    depositMethods () {
      return this.$store.getters.getDepositMethods
    },
    depositSettings() {
      return this.$store.getters.getDepositSettings
    }
  },
  methods: {
    getPictureUrl (url) {
      return url
    },
    selectMethod (selected) {
      if (!this.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для пополнения баланса нужно авторизоваться')
      }
      this.amountAlert = false;
      this.selectedMethod.name = selected.name
      this.selectedMethod.id = selected.id
      this.selectedMethod.module = selected.method_module
      this.selectedMethod.method_id = selected.method_id
      this.selectedMethod.minAmount = selected.min_amount
      this.selectedMethod.maxAmount = selected.max_amount
      if(selected.method_module == 'adwin'){
        this.amountAlert = true;
      }
      const elem = document.querySelector('#deposit-area')
      let position = elem.getBoundingClientRect().top + document.documentElement.scrollTop
      position = parseInt(position)
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      })
      setTimeout(() => {
        document.getElementById('depositAmount').focus()
      }, 500)
    },
    payInFormSubmit (e) {
      if (!this.userData) {
        e.preventDefault()
        this.formResponse = { status: 'error', msg: 'Unauthorized' }
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 500)
        return
      }
      const payInAmount = parseFloat(this.$refs.depositAmount.value) || 0
      if (!payInAmount > 0) {
        e.preventDefault()
        this.formResponse = { status: 'error', msg: 'Пожалуйста, укажите правильую сумму' }
        return false
      }
      if (!this.selectedMethod.id || !this.selectedMethod.module) {
        e.preventDefault()
        this.formResponse = { status: 'error', msg: 'Пожалуйста выберите метод депозита' }
        return false
      }
      return true
    }
  },
  mounted () {
    window.scrollTo({
      top: 0
    });
  },
  watch : {
    sum() {
      const payInAmount = parseFloat(this.$refs.depositAmount.value) || 0
      if (payInAmount != this.sum) {
        this.sum = payInAmount
        return this.formResponse = { status: 'error', msg: 'Пожалуйста, укажите правильую сумму' }
      } else {
        return this.formResponse = {}
      }
    }
  }
}
</script>

<style>
  .payin-info{
    margin: 0;
  }
  .pay-amount-info{
    font-size: 15px;
  }
  .red-color{
   color: #f1332e;
  }

  .pay-method-info{
    font-size: 14px;
  }
  .choose-method-txt,
  .deposit-hint {
    font-size: 16px;
  }
  .deposit-form input {
    border-radius: 30px;
  }
  .paymethod-label {
    margin: 10px;
    background-color: white;
    height: 80px;
    padding: 5px;
    text-align: center;
    display: flex;
    color: black;
  }
  .min-amount-label{
    font-size: 13px;
    width: 50%;
    display: flex;
    justify-content: right;
    align-items: center;
}
  .pay-method-itm-style {
    float: left;
    cursor: pointer;
    border-radius: 3px;
    border: solid 1px transparent;
    box-shadow: 0 0 3px 1px white;
  }
  .promo-method{
    background-color: transparent;
    padding-top: 0;
    box-shadow: unset;
  }

  .pay-method-image {
    max-width: 50%;
    max-height: 100%;
    height: 80px;
    object-fit: scale-down;
    border-radius: 4px;
  }

  .pay-method-itm-style.selected,
  .pay-method-itm-style:hover{
    background-origin: border-box;
    background-clip: padding-box, border-box;
    box-shadow: 0 0 15px 2px #f1332e;
  }
</style>

